export var FeatureFlagEnum;
(function (FeatureFlagEnum) {
    // Tim added this on 02/23/23 expected to remove in ??
    FeatureFlagEnum["RELEASE_GATE_CHARACTER_SHEET_TOUR"] = "release-gate-character-sheet-tour";
    // Brittany added this on 2/24/2023
})(FeatureFlagEnum || (FeatureFlagEnum = {}));
export const FEATURE_FLAG_LIST = [
    FeatureFlagEnum.RELEASE_GATE_CHARACTER_SHEET_TOUR,
];
export const DEFAULT_FEATURE_FLAG_INFO = {
    [FeatureFlagEnum.RELEASE_GATE_CHARACTER_SHEET_TOUR]: false,
};
